__turbopack_context__.v({
  "barArea": "Ck9-KG_barArea",
  "navButton": "Ck9-KG_navButton",
  "navButtonIcon": "Ck9-KG_navButtonIcon",
  "navButtonPlaceholder": "Ck9-KG_navButtonPlaceholder",
  "navigationWrapper": "Ck9-KG_navigationWrapper",
  "progressionBarText": "Ck9-KG_progressionBarText",
  "wrapper": "Ck9-KG_wrapper",
});
